var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-dashboard',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"mb-4"},[_vm._v("Perfil de usuario")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }